_gg.onReady.isInIFrame = function () {
    if (window.self != window.top) {
        // is in iframe
        document.documentElement.classList.add('-in-iframe');

        // Select appointment type "consultation" by default
        [
            ...document.querySelectorAll(
                '#appointment-appointmentType input[value=consultation]'
            ),
        ].forEach((radio) => {
            radio.checked = true;
        });
    }
};
